export default {
      id: "download-kind-2-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#download-kind-2-usage",
      toString: function () {
        return this.url;
      }
    }